import andrew from "./images/Dr Andrew.jpg"
import michelle from "./images/Dr Michelle.jpg"
import steve from "./images/Dr Steve.jpg"

const doctors = [
    {
        image: steve,
        name: "Dr. Andrew White, 32",
        department: "Tabacologue"
    },
    {
        image: michelle,
        name: "Dr. Michelle Grey, 40",
        department: "Addictologue"
    },
    {
        image: andrew,
        name: "Dr. Steve Johnson, 49",
        department: "Pneumologue"
    },
]

export default doctors
